import { forterService } from '@/services/forterService';
import { forterDiagnostics, type ForterTokenSource } from '@/utils/forterDiagnostics';

/**
 * Get the Forter token from the Forter service
 * Falls back to reading from cookies if service is not initialized
 *
 * ACDEV-27224: this is the literal moment the value shipped to the BE as
 * `forterTokenCookie` is read, so it's where the pay-time RUM checkpoint
 * belongs — see `forterDiagnostics.tokenReadAtPayTime`, which owns the
 * logging (and can never throw), so this stays a pure lookup.
 */
export const getForterToken = (): string => {
  const serviceToken = forterService.getToken();
  const token = serviceToken || getForterTokenFromCookie();

  const source: ForterTokenSource = serviceToken ? 'service' : token ? 'cookie' : 'none';
  forterDiagnostics.tokenReadAtPayTime(source, () => forterService.isInitialized());

  return token;
};

/**
 * Legacy function to read Forter token from cookies
 * Used as fallback if service is not available
 */
const getForterTokenFromCookie = (): string => {
  if (typeof document === 'undefined') {
    return '';
  }

  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const [name, value] = cookie.trim().split('=');
    if (name === 'forterToken' || name === '_ftr') {
      return decodeURIComponent(value);
    }
  }
  return '';
};
